import MiIcon from './MiIcon.vue'

export default MiIcon
